import { render, staticRenderFns } from "./customUpload.vue?vue&type=template&id=3f4e75b7&"
import script from "./customUpload.vue?vue&type=script&lang=js&"
export * from "./customUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports